import React from "react";
import { withTranslation } from "react-i18next";

import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import Text from "components/Text";
import "./../../ManageCatalogue.scss";
function ErrorImages({ t, closeModel, details }) {
  return (
    <Modal
      id="upload-error-modal"
      isOpen={true}
      toggle={closeModel}
      className={
        "modal-dialog-centered modal-width-660 modal-content-padding-small "
      }
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModel}>
        <img src={require("assets/images/cross.svg").default} alt="close" />
      </span>

      <ModalBody>
        <div className="modal-custom-title">
          <Text size="25px" marginBottom="40px" weight="500" color="#111B45">
            <span className="modal-title-25">
              {t("vendorManagement.uploadError")}
            </span>
          </Text>
        </div>

        <ul className="list-group">
          {details.map((item, index) => (
            <li className="list-group-item" key={index}>
              <img
                src={require("assets/images/error.svg").default}
                alt="icon"
              />{" "}
              {item?.fileName}{" "}
            </li>
          ))}
        </ul>
        <div className="text-center">
          <button
            className="button button-round button-border btn-mobile-link button-dark"
            onClick={closeModel}
            title={t("close")}
          >
            {t("close")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(ErrorImages);
